<template>
  <el-dialog
    title="优惠券"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleClose"
  >
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card header="flex justify-between">
          <el-row :gutter="20">
            <el-col :span="18"></el-col>
            <el-col :span="6">
              <el-input-group>
                <el-input
                  v-model="chooseCouponPoolSendParkingInfo._currentCouponPoolName"
                  placeholder="输入优惠券池名称"
                ></el-input>
                <el-button
                  slot="append"
                  type="primary"
                  @click="queryCouponPools"
                >查询</el-button>
              </el-input-group>
            </el-col>
          </el-row>

          <el-table
            :data="chooseCouponPoolSendParkingInfo.couponPools"
            style="width: 100%;margin-top:15px"
            border
            stripe
          >
            <el-table-column prop="poolId" label="优惠券池编码" align="center"></el-table-column>
            <el-table-column prop="couponName" label="优惠券名称" align="center"></el-table-column>
            <el-table-column prop="actualPrice" label="面值" align="center"></el-table-column>
            <el-table-column prop="stock" label="库存" align="center"></el-table-column>
            <el-table-column prop="validityDay" label="有效期" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="chooseCouponPoolSendParking(scope.row)"
                >选择</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
            class="pagination"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { listCouponShopPool } from '@/api/goods/couponShopPoolApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ChooseCouponPoolSendParking',
  data() {
    return {
      dialogVisible: false,
      chooseCouponPoolSendParkingInfo: {
        couponPools: [],
        _currentCouponPoolName: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._refreshchooseCouponPoolSendParkingInfo()
      this._loadSendCouponPoolSendParkingInfo()
    },
    handleClose() {
      this.chooseCouponPoolSendParkingInfo._currentCouponPoolName = ''
    },
    async _loadSendCouponPoolSendParkingInfo() {
      const params = {
        page: this.currentPage,
        row: this.pageSize,
        shopId: getShopId(),
        name: this.chooseCouponPoolSendParkingInfo._currentCouponPoolName
      }
      try {
        const res = await listCouponShopPool(params)
        this.chooseCouponPoolSendParkingInfo.couponPools = res.data
        this.total = res.records
      } catch (error) {
        console.error(error)
      }
    },
    chooseCouponPoolSendParking(couponPool) {
      if (Object.prototype.hasOwnProperty.call(couponPool,'name')) {
        couponPool.couponPoolName = couponPool.name
      }
      this.$emit('choose', couponPool)
      this.dialogVisible = false
    },
    queryCouponPools() {
      this.currentPage = 1
      this._loadSendCouponPoolSendParkingInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._loadSendCouponPoolSendParkingInfo()
    },
    _refreshchooseCouponPoolSendParkingInfo() {
      this.chooseCouponPoolSendParkingInfo._currentCouponPoolName = ""
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 15px;
  text-align: right;
}
</style>